import { lazy } from 'react'
import suspenseComponent from '../../../util/suspenseComponent'

const InputAddressLazy = lazy(() => import('./InputAddress'))
const InputAddress = suspenseComponent(InputAddressLazy)

export default InputAddress
